<template>
  <div class="row col-12 q-gutter-xs text-brand-5 text-weight-bold">
    <div v-if="unidade" :class="classUnidade">
      <div class="texto-titulo-input">Unidade</div>
      <SelecaoUnidade
        :model="$store.state.org.unidadeData"
        @enviarUnidade="receberUnidade"
      />
    </div>
    <div v-if="fornecedor" :class="classFornecedor">
      <div class="texto-titulo-input">Fornecedor</div>
      <SelecaoFornecedor
        class="input-new-design"
        :unidadeId="filtros?.unidade?.id"
        :desabilitado="true"
        :unidadeTransferenciaId="unidadeTransferenciaId"
        @enviarFornecedor="receberFornecedor"
      />
    </div>
    <div v-if="codigo" :class="classCodigo">
      <div class="texto-titulo-input">Código</div>
      <q-input
        class="input input-new-design"
        debounce="500"
        v-model="filtros.codigo"
        label="Digite o Código"
        label-color="grey-6"
        dense
        outlined
      />
    </div>
    <div v-if="descricao" :class="classDescricao">
      <div class="texto-titulo-input">Descrição</div>
      <q-input
        class="input input-new-design"
        debounce="500"
        v-model="filtros.descricao"
        label="Digite a Descrição"
        label-color="grey-6"
        dense
        outlined
      />
    </div>
    <div v-if="patrimonio" :class="classPatrimonio">
      <div class="texto-titulo-input">Patrimônio</div>
      <q-input
        class="input input-new-design"
        debounce="500"
        v-model="filtros.patrimonio"
        label="Digite o Patrimônio"
        label-color="grey-6"
        dense
        outlined
      />
    </div>
    <div v-if="subgrupo" :class="classGrupo">
      <div class="texto-titulo-input">Grupo</div>
      <SelecaoGrupo
        class="input-new-design"
        :grupoUuid="filtros?.subgrupo?.catalogoGrupoUuid"
        @enviarGrupo="receberGrupoFiltro"
      />
    </div>
    <div v-if="subgrupo" :class="classSubgrupo">
      <div class="texto-titulo-input">Subgrupo</div>
      <SelecaoSubgrupo
        class="input-new-design"
        :grupoUuid="filtros?.grupo?.catalogoGrupoUuid"
        @enviarSubgrupo="receberSubgrupoFiltro"
      />
    </div>
    <div v-if="solicitante" :class="classSolicitante">
      <div class="texto-titulo-input">Solicitante</div>
      <SelecaoFuncionario
        class="input-new-design"
        @emitirFuncionario="receberFuncionario"
      />
    </div>
    <div v-if="numeroReserva" :class="classNumeroReserva">
      <div class="texto-titulo-input">Nº Reserva</div>
      <q-input
        class="input input-new-design"
        debounce="500"
        v-model="filtros.numeroReserva"
        dense
        outlined
        label="Digite o Numero"
        label-color="grey-6"
      />
    </div>
    <div v-if="statusReserva" :class="classStatusReserva">
      <div class="texto-titulo-input">Status Reserva</div>
      <q-select
        class="input input-new-design"
        v-model="filtros.statusReserva"
        behavior="menu"
        option-label="label"
        option-value="value"
        label="Selecione o Status"
        label-color="grey-6"
        :options="options.statusReservaOptions"
        dense
        outlined
      />
    </div>
    <div v-if="statusTransferencia" :class="classStatusTransferencia">
      <div class="texto-titulo-input">Status</div>
      <q-select
        class="input input-new-design"
        v-model="filtros.statusTransferencia"
        behavior="menu"
        option-label="label"
        option-value="value"
        label="Selecione o Status"
        label-color="grey-6"
        :options="options.statusTransferencia"
        dense
        outlined
      />
    </div>
    <div v-if="numeroTransferencia" :class="classNumeroTransferencia">
      <div class="texto-titulo-input">Nº Transferência</div>
      <q-input
        class="input input-new-design"
        debounce="500"
        v-model="filtros.numeroTransferencia"
        dense
        outlined
        label="Digite o Numero"
        label-color="grey-6"
      />
    </div>
    <div v-if="dataInicial" :class="classDataInicial">
      <div class="texto-titulo-input">Data Inicial</div>
      <q-input
        class="input input-new-design"
        dense
        outlined
        placeholder="DD/MM/AAAA"
        mask="##/##/####"
        label="Digite a Data"
        label-color="grey-6"
        v-model="filtros.dataInicial"
        :rules="[
          (val) => val == '' || val.length == 10 || 'Digite a Data Completa',
        ]"
      >
        <template v-slot:append>
          <q-icon name="event" class="cursor-pointer">
            <q-popup-proxy
              cover
              transition-show="scale"
              transition-hide="scale"
            >
              <q-date
                v-model="filtros.dataInicial"
                :locale="myLocale"
                mask="DD/MM/YYYY"
                :rules="[
                  (val) =>
                    val == '' || val.length == 10 || 'Digite a Data Completa',
                ]"
              >
                <div class="row items-center justify-end">
                  <q-btn v-close-popup label="Fechar" color="primary" flat />
                </div>
              </q-date>
            </q-popup-proxy>
          </q-icon>
        </template>
      </q-input>
    </div>
    <div v-if="dataFinal" :class="classDataFinal">
      <div class="texto-titulo-input">Data Final</div>
      <q-input
        class="input input-new-design"
        dense
        outlined
        placeholder="DD/MM/AAAA"
        mask="##/##/####"
        label="Digite a Data"
        label-color="grey-6"
        v-model="filtros.dataFinal"
        :rules="[
          (val) => val == '' || val.length == 10 || 'Digite a Data Completa',
        ]"
      >
        <template v-slot:append>
          <q-icon name="event" class="cursor-pointer">
            <q-popup-proxy
              cover
              transition-show="scale"
              transition-hide="scale"
            >
              <q-date
                v-model="filtros.dataFinal"
                :locale="myLocale"
                mask="DD/MM/YYYY"
                :rules="[
                  (val) =>
                    val == '' || val.length == 10 || 'Digite a Data Completa',
                ]"
              >
                <div class="row items-center justify-end">
                  <q-btn v-close-popup label="Fechar" color="primary" flat />
                </div>
              </q-date>
            </q-popup-proxy>
          </q-icon>
        </template>
      </q-input>
    </div>
    <div v-if="statusMovimentacao" :class="classStatusMovimentacao">
      <div class="texto-titulo-input">Status</div>
      <SelecaoStatus class="input-new-design" @enviarStatus="receberStatus" />
    </div>
    <div v-if="listarTodos" :class="classListarTodos">
      <div class="texto-titulo-input q-mb-sm">Listar Todos</div>
      <q-toggle
        class="input input-new-design"
        debounce="500"
        v-model="filtros.listarTodos"
        :label="filtros.listarTodos ? 'Sim' : 'Não'"
        dense
        outlined
      />
    </div>
  </div>
</template>

<script>
import { ref, watch } from "vue";

import SelecaoGrupo from "./SelecaoGrupo.vue";
import SelecaoSubgrupo from "./SelecaoSubgrupo.vue";
import SelecaoFuncionario from "./SelecaoFuncionario.vue";
import SelecaoStatus from "./SelecaoStatus.vue";
import { watchDebounced } from "@vueuse/core";
import SelecaoUnidade from "./SelecaoUnidade.vue";
import SelecaoFornecedor from "./SelecaoFornecedor.vue";
import { salvarCatalogoUuid } from "../../ferramentaria/composables/salvarCatalogoUuid";

export default {
  props: {
    unidadeTransferenciaId: {
      type: Number,
    },
    unidade: {
      type: Boolean,
    },
    codigo: {
      type: Boolean,
    },
    descricao: {
      type: Boolean,
    },
    patrimonio: {
      type: Boolean,
    },
    subgrupo: {
      type: Boolean,
    },
    solicitante: {
      type: Boolean,
    },
    fornecedor: {
      type: Boolean,
    },
    numeroReserva: {
      type: Boolean,
    },
    dataInicial: {
      type: Boolean,
    },
    dataFinal: {
      type: Boolean,
    },
    statusReserva: {
      type: Boolean,
    },
    listarTodos: {
      type: Boolean,
    },
    numeroTransferencia: {
      type: Boolean,
    },
    statusTransferencia: {
      type: Boolean,
    },
    statusMovimentacao: {
      type: Boolean,
    },
    classUnidade: {
      type: String,
    },
    classCodigo: {
      type: String,
    },
    classSolicitante: {
      type: String,
    },
    classDescricao: {
      type: String,
    },
    classPatrimonio: {
      type: String,
    },
    classGrupo: {
      type: String,
    },
    classSubgrupo: {
      type: String,
    },
    classNumeroReserva: {
      type: String,
    },
    classDataInicial: {
      type: String,
    },
    classDataFinal: {
      type: String,
    },
    classStatusReserva: {
      type: String,
    },
    classStatusMovimentacao: {
      type: String,
    },
    classListarTodos: {
      type: String,
    },
    classStatusTransferencia: {
      type: String,
    },
    classFornecedor: {
      type: String,
    },
    classNumeroTransferencia: {
      type: String,
    },
  },
  emits: ["enviarFiltro"],
  components: {
    SelecaoGrupo,
    SelecaoSubgrupo,
    SelecaoFuncionario,
    SelecaoStatus,
    SelecaoFornecedor,
    SelecaoUnidade,
  },
  setup(props, { emit }) {
    const catalogoUuid = salvarCatalogoUuid();
    const filtros = ref({
      codigo: "",
      descricao: "",
      patrimonio: "",
      grupo: "",
      subgrupo: "",
      solicitante: "",
      numeroReserva: "",
      dataInicial: "",
      dataFinal: "",
      statusReserva: "",
      statusMovimentacao: "",
      listarTodos: false,
      statusTransferencia: "",
      unidade: "",
      numeroTransferencia: "",
    });
    const options = ref({
      statusReservaOptions: [
        { label: "Em Aberta", value: "disponivel" },
        { label: "Finalizada", value: "finalizado" },
      ],
      statusTransferencia: [
        { label: "Criada", value: "criada" },
        { label: "Enviada", value: "enviada" },
        { label: "Recebida", value: "recebida" },
        { label: "Cancelada", value: "cancelada" },
      ],
    });

    const enviarFiltro = () => {
      emit("enviarFiltro", filtros.value);
    };

    const receberGrupoFiltro = (value) => {
      if (value === null || value === undefined) {
        filtros.value.grupo = "";
        return;
      }
      filtros.value.grupo = value;
    };

    const receberSubgrupoFiltro = (value) => {
      if (value === null || value === undefined) {
        filtros.value.subgrupo = "";
        return;
      }
      filtros.value.subgrupo = value;
    };

    const receberFuncionario = (value) => {
      filtros.value.solicitante = value;
    };

    const receberStatus = (value) => {
      filtros.value.statusMovimentacao = value;
    };

    const receberFornecedor = (value) => {
      filtros.value.fornecedor = value;
    };

    const receberUnidade = (value) => {
      if (filtros.value.unidade?.id == value?.id) {
        return;
      }
      filtros.value.unidade = value;
    };

    watch(
      () => filtros.value.grupo,
      () => {
        enviarFiltro();
      }
    );

    watch(
      () => filtros.value.subgrupo,
      () => {
        enviarFiltro();
      }
    );

    watchDebounced(
      [
        () => filtros.value.codigo,
        () => filtros.value.descricao,
        () => filtros.value.patrimonio,
        () => filtros.value.solicitante,
        () => filtros.value.numeroReserva,

        () => filtros.value.statusReserva,
        () => filtros.value.statusMovimentacao,
        () => filtros.value.dataInicial,
        () => filtros.value.dataFinal,
        () => filtros.value.statusReserva,
        () => filtros.value.listarTodos,
        () => filtros.value.numeroTransferencia,
        () => filtros.value.unidade,
        () => filtros.value.fornecedor,
      ],
      () => {
        if (
          filtros.value.dataInicial != "" &&
          filtros.value.dataInicial.length != 10
        ) {
          return;
        }
        if (
          filtros.value.dataFinal != "" &&
          filtros.value.dataFinal.length != 10
        ) {
          return;
        }
        enviarFiltro();
      },
      { debounce: 400 }
    );

    return {
      filtros,
      receberGrupoFiltro,
      receberSubgrupoFiltro,
      receberFuncionario,
      receberStatus,
      receberUnidade,
      receberFornecedor,
      catalogoUuid,
      options,
      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
    };
  },
};
</script>

<style scoped>
@media (max-width: 600px) {
  .texto-titulo-input {
    font-size: 12px;
  }
  .input {
    font-size: 12px;
  }
}
</style>

<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}

.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}
</style>
